import { Host, h } from "@stencil/core";
const DROPDOWN_ITEM = "ch-dropdown-item";
export class ChDropDownItem {
    constructor() {
        this.hasItems = false;
        this.expandBehavior = "ClickOrHover";
        this.forceContainingBlock = true;
        this.href = undefined;
        this.leftImgSrc = undefined;
        this.openOnFocus = false;
        this.position = "Center_OutsideEnd";
        this.rightImgSrc = undefined;
        this.shortcut = undefined;
    }
    mainElement;
    el;
    /**
     * Fires when the control's anchor or button is clicked.
     */
    actionClick;
    /**
     * Fired when the visibility of the dropdown section is changed
     */
    expandedChange;
    /**
     * Fires when the control's anchor or button is in focus.
     */
    focusChange;
    /**
     * Focuses the control's anchor or button.
     */
    async handleFocusElement() {
        this.mainElement.focus();
    }
    dropDownItemContent = () => [
        !!this.leftImgSrc && (h("img", { slot: "action", "aria-hidden": "true", class: "start-img", part: "start-img", alt: "", src: this.leftImgSrc, loading: "lazy" })),
        h("span", { slot: "action", class: "content", part: "content" }, h("slot", null)),
        !!this.shortcut && (h("span", { "aria-hidden": "true", slot: "action", part: "shortcut" }, this.shortcut)),
        !!this.rightImgSrc && (h("img", { slot: "action", "aria-hidden": "true", class: "end-img", part: "end-img", alt: "", src: this.rightImgSrc, loading: "lazy" }))
    ];
    checkItems = () => {
        this.hasItems = !!this.el.querySelector(`:scope>${DROPDOWN_ITEM}`);
    };
    noItemsRender = () => this.href ? (h("a", { class: "action", part: "action link", href: this.href, onClick: this.handleActionClick, onFocus: this.handleFocus, ref: el => (this.mainElement = el) }, this.dropDownItemContent(), h("slot", { name: "items", onSlotchange: this.checkItems }))) : (h("button", { class: "action", part: "action button", type: "button", onClick: this.handleActionClick, onFocus: this.handleFocus, ref: el => (this.mainElement = el) }, this.dropDownItemContent(), h("slot", { name: "items", onSlotchange: this.checkItems })));
    itemsRender = () => (h("ch-dropdown", { class: "action", exportparts: "expandable-button:action,expandable-button:button,expandable-button:expandable-action,separation,list,section,mask,header,footer,window", expandBehavior: this.expandBehavior, nestedDropdown: true, openOnFocus: this.openOnFocus, position: this.position }, this.dropDownItemContent(), h("slot", { name: "items", slot: "items", onSlotchange: this.checkItems })));
    handleActionClick = () => {
        this.actionClick.emit(this.el.id);
    };
    handleFocus = () => {
        this.focusChange.emit();
    };
    componentWillLoad() {
        this.checkItems();
    }
    render() {
        return (h(Host, { role: "listitem" }, this.hasItems ? this.itemsRender() : this.noItemsRender()));
    }
    static get is() { return "ch-dropdown-item"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["dropdown-item.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["dropdown-item.css"]
        };
    }
    static get properties() {
        return {
            "expandBehavior": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"Click\" | \"ClickOrHover\"",
                    "resolved": "\"Click\" | \"ClickOrHover\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Determine which actions on the expandable button display the dropdown\nsection.\nOnly works if the control has subitems."
                },
                "attribute": "expand-behavior",
                "reflect": false,
                "defaultValue": "\"ClickOrHover\""
            },
            "forceContainingBlock": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "`true` to force the control to make its own containing block."
                },
                "attribute": "force-containing-block",
                "reflect": true,
                "defaultValue": "true"
            },
            "href": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Specifies the hyperlink of the item. If this property is defined, the\ncontrol will render an anchor tag with this `href`. Otherwise, it will\nrender a button tag."
                },
                "attribute": "href",
                "reflect": false
            },
            "leftImgSrc": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Specifies the src for the left img."
                },
                "attribute": "left-img-src",
                "reflect": false
            },
            "openOnFocus": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Determine if the dropdown section should be opened when the expandable\nbutton of the control is focused.\nOnly works if the control has subitems."
                },
                "attribute": "open-on-focus",
                "reflect": false,
                "defaultValue": "false"
            },
            "position": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "DropdownPosition",
                    "resolved": "\"Center_OutsideEnd\" | \"Center_OutsideStart\" | \"InsideEnd_OutsideEnd\" | \"InsideEnd_OutsideStart\" | \"InsideStart_OutsideEnd\" | \"InsideStart_OutsideStart\" | \"OutsideEnd_Center\" | \"OutsideEnd_InsideEnd\" | \"OutsideEnd_InsideStart\" | \"OutsideEnd_OutsideEnd\" | \"OutsideEnd_OutsideStart\" | \"OutsideStart_Center\" | \"OutsideStart_InsideEnd\" | \"OutsideStart_InsideStart\" | \"OutsideStart_OutsideEnd\" | \"OutsideStart_OutsideStart\"",
                    "references": {
                        "DropdownPosition": {
                            "location": "import",
                            "path": "../dropdown/types",
                            "id": "src/components/dropdown/types.ts::DropdownPosition"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Specifies the position of the dropdown section that is placed relative to\nthe expandable button."
                },
                "attribute": "position",
                "reflect": false,
                "defaultValue": "\"Center_OutsideEnd\""
            },
            "rightImgSrc": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Specifies the src for the right img."
                },
                "attribute": "right-img-src",
                "reflect": false
            },
            "shortcut": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Specifies the shortcut caption that the control will display."
                },
                "attribute": "shortcut",
                "reflect": false
            }
        };
    }
    static get states() {
        return {
            "hasItems": {}
        };
    }
    static get events() {
        return [{
                "method": "actionClick",
                "name": "actionClick",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Fires when the control's anchor or button is clicked."
                },
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                }
            }, {
                "method": "expandedChange",
                "name": "expandedChange",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Fired when the visibility of the dropdown section is changed"
                },
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                }
            }, {
                "method": "focusChange",
                "name": "focusChange",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Fires when the control's anchor or button is in focus."
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get methods() {
        return {
            "handleFocusElement": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "Focuses the control's anchor or button.",
                    "tags": []
                }
            }
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=dropdown-item.js.map
